import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Label, Icon, Header, Grid, Segment, Button, Modal } from 'semantic-ui-react'
import geolib from 'geolib'

import get from 'lodash/get'
import map from 'lodash/map'
import size from 'lodash/size'
import filter from 'lodash/filter'
import capitalize from 'lodash/capitalize'

class ModalDriversPackage extends PureComponent {
  state = {
    selectedSize: 'all',
    nearestSize: null,
    confirming: false,
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible) {
      this.findNearest(nextProps)
    }
  }

  findNearest = nextProps => {
    const { order } = nextProps
    const driversLocation = {}

    const availableDrivers = this.getAvailableDriverBySize('all', nextProps.allDrivers)

    const merchantLocation = get(order, 'etaInfo.info.legs.0.start_location', {})

    const targetCoords = {
      latitude: merchantLocation.lat,
      longitude: merchantLocation.lng,
    }

    map(availableDrivers, driver => {
      if (driver.location) {
        driversLocation[driver.tel] = {
          latitude: driver.location.latitude,
          longitude: driver.location.longitude,
        }
      }
    })

    if (size(driversLocation) > 0) {
      const nearestDriver = geolib.findNearest(targetCoords, driversLocation)

      if (nearestDriver && nearestDriver.key) {
        const foundDriver = nextProps.allDrivers[nearestDriver.key]

        this.setState({ nearestSize: foundDriver.package_size })
      }
    }
  }

  onConfirmWithPackage = async () => {
    try {
      const { selectedSize } = this.state
      const { order } = this.props

      this.setState({ confirming: true })

      const params = {
        findDriver: true,
        packageSize: selectedSize,
        orderUid: order.key,
        branchUid: order.restaurant.branch.key,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'confirm', ...params })

      this.setState({ confirming: false }, this.onModalClose)
    } catch (error) {
      this.setState({ confirming: false })
      alert(error.message || error)
    }
  }

  getAvailableDriverBySize = (packageValue, allDrivers) => {
    return filter(
      allDrivers,
      driver =>
        (packageValue === 'all' || driver.package_size === packageValue)
        && driver.online
        && driver.status === 'available'
    )
  }

  onModalClose = () => {
    const { onCancel } = this.props

    this.setState({ selectedSize: 'all', nearestSize: null }, onCancel)
  }

  onCancelClick = () => this.onModalClose()

  onConfirmClick = () => this.onConfirmWithPackage()

  renderEachPackageColumn = packageValue => {
    const { allDrivers } = this.props
    const { nearestSize, selectedSize } = this.state

    const availableDrivers = this.getAvailableDriverBySize(packageValue, allDrivers)
    const isSelected = selectedSize === packageValue
    const isHasNearest = nearestSize === packageValue
    const segmentProps = isSelected ? { inverted: true, color: 'green' } : {}

    return (
      <Grid.Column key={packageValue}>
        <Segment
          {...segmentProps}
          style={{ cursor: 'pointer' }}
          onClick={() => this.setState({ selectedSize: packageValue })}
        >
          <Header textAlign="center">{capitalize(packageValue)}</Header>
          <div style={{ textAlign: 'center' }}>
            <Label color={size(availableDrivers) > 0 ? 'green' : 'red'}>
              <Icon name="bicycle" />
              {`${size(availableDrivers)} Drivers available`}
            </Label>
          </div>
          {isHasNearest && (
            <div style={{ position: 'absolute', top: 4, right: 4 }}>
              <div style={{ background: 'orange', height: 10, width: 10, borderRadius: 5 }} />
            </div>
          )}
        </Segment>
      </Grid.Column>
    )
  }

  renderPackageColumns = () => {
    const PACKAGES = ['all', 'small', 'medium', 'large']

    return map(PACKAGES, packageValue => this.renderEachPackageColumn(packageValue))
  }

  render() {
    const { visible } = this.props
    const { confirming } = this.state

    return (
      <Modal
        open={visible}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        style={{ marginTop: 0, width: '60vw' }}
      >
        <Modal.Header>Choose Package size</Modal.Header>
        <Modal.Content>
          <Grid columns="equal">
            <Grid.Row>{this.renderPackageColumns()}</Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button negative disabled={confirming} onClick={this.onCancelClick}>
            Cancel
          </Button>
          <Button
            secondary
            content="Confirm"
            loading={confirming}
            disabled={confirming}
            onClick={this.onConfirmClick}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ drivers }) => ({ allDrivers: drivers.drivers })

export default connect(mapState)(ModalDriversPackage)



// WEBPACK FOOTER //
// ./src/components/orders/ModalDriversPackage.js